import { combineReducers } from 'redux';
import config from 'reducers/config';
import places from 'reducers/places';
import targets from 'reducers/targets';
import files from "./reducers/files";
import targetAnalytics from 'reducers/targetAnalytics';
import placeAnalytics from 'reducers/placeAnalytics';
import users from "./reducers/users";
import cities from "./reducers/cities";
import categories from './reducers/categories';

export default combineReducers({
    config,
    places,
    targets,
    files,
    targetAnalytics,
    placeAnalytics,
    users,
    cities,
    categories,
});


// WEBPACK FOOTER //
// ./src/rootReducer.js